/**
 * Centralized environment variable access for the frontend.
 *
 * All BUN_PUBLIC_* variables should be accessed through this module.
 * Bun's --env='BUN_PUBLIC_*' flag inlines process.env.* references at
 * build time when the variables are set in the environment.
 *
 * When bun DOES inline (production build with env vars set):
 *   process.env.BUN_PUBLIC_API_ADDRESS → "https://api.mgr.example.com"
 *   The expression becomes: "https://api.mgr.example.com" || "fallback"
 *   Result: the actual value.
 *
 * When bun does NOT inline (vars missing during build):
 *   process.env.BUN_PUBLIC_API_ADDRESS stays as-is.
 *   A polyfill <script> in index.html provides `window.process = { env: {} }`
 *   so the expression evaluates to undefined || "fallback".
 *   Result: the fallback value (suitable for local dev).
 *
 * This ensures the app never crashes with "ReferenceError: process is not defined".
 */

// NOTE: Keep the process.env.BUN_PUBLIC_* references EXACTLY as shown.
// Bun's --env flag does literal string matching on these expressions.
// Do NOT use destructuring, aliasing, or computed property access.

export const API_ADDRESS: string = process.env.BUN_PUBLIC_API_ADDRESS || "http://localhost:8080";

export const AUTH0_DOMAIN: string = process.env.BUN_PUBLIC_AUTH0_DOMAIN || "dev-szqbxi0ysd88ilop.us.auth0.com";

export const AUTH0_CLIENT_ID: string = process.env.BUN_PUBLIC_AUTH0_CLIENT_ID || "";

export const AUTH0_AUDIENCE: string = process.env.BUN_PUBLIC_AUTH0_AUDIENCE || "main-api";

export const TELEGRAM_BOT_USERNAME: string = process.env.BUN_PUBLIC_TELEGRAM_BOT_USERNAME || "memorize_lessons_test_bot";
